import { Icon, Modal } from 'semantic-ui-react';
import React, {Component} from 'react'
import Single from '../../../componentes/Single'
import {Dropdown} from 'semantic-ui-react'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';

class Rechazos extends Component{
	constructor(props){
		super(props);
		this.newRegistro = this.newRegistro.bind(this);
		this.app= firebase;
		this.database = this.app.firestore().collection('Produccion');
		this.state = {
			useModal: false,
		}
	}

	newRegistro(data){
		this.database.add({
            fecha: data.fecha,
			variedad: data.variedad,
			sector: data.sector,
			empleado:'Rechazadas',
            fruta: data.fruta,
            totalCajas: data.totalCajas,
            totalBotes: data.totalCajas*2,
		})
		.then(()=>{
			//alert(':)')
		})
		.catch(e=>{
			alert(e)
		})
	}
	modalAgregar = () => (
		<Modal 
			onClose={() => this.changeUsModal(false)}
			onOpen={() => this.changeUsModal(true)}
			open={this.state.useModal}
			trigger={<button><Icon name='plus' />Rechazos</button>}>
			<Modal.Header>Agregar Rechazos de Hoy</Modal.Header>
			<Modal.Content>
				<NuevoRegistro newRegistro={this.newRegistro} changeModal={this.changeUsModal} />
			</Modal.Content>
		</Modal>
	)
	changeUsModal=(open)=>{
		this.setState({useModal:open})
	}
	render(){
		return (
			<this.modalAgregar />
		);
	}
}

class NuevoRegistro extends Component{
	constructor(props){
		super(props);
        const today = new Date();
        const date = today.getDate()+'/'+(today.getMonth()+1)+'/'+today.getFullYear()+' '+today.getHours()+':'+today.getMinutes();
		this.state = {
			date: date,
            fecha: today,
			variedad: '',
			sector: '',
			empleado:'Rechazadas',
            fruta:'',
            totalCajas: 0,
		};
		this.handleUserInput = this.handleUserInput.bind(this);
		this.writeNew = this.writeNew.bind(this);
		this.changeModal= this.props.changeModal;
	}

	handleUserInput(event){
		this.setState({
			[event.target.name]: event.target.value
		})
	}
    handleSectorChange= async (e, {value})=>{
		const data =  firebase.firestore().collection('Zonas')
        const filtro = data.where('sector', '==', value)
		const variedad = await filtro.get()
		if (variedad.empty) {
			this.setState({
				sector:value,
				variedad:''
			})
		  }
		  variedad.forEach(doc => {
			this.setState({
				sector:value,
				variedad:doc.data().variedad
			})
		  });
    }
    handleCajasChange=(event)=>{
        this.setState({[event.target.name]: 0-event.target.value})
    }
    handleFrutaChange=(e, {value})=>{
        this.setState({fruta:value})
    }

	writeNew(event){
		event.preventDefault()
        const data = {...this.state};
		this.props.newRegistro(data);
		this.setState({
			variedad: '',
			sector: '',
            fruta:'',
            totalCajas: 0,
		})
		this.changeModal(false)
	}

	render(){
		return(
			<div>
				<form onSubmit={this.writeNew}>
					<div className="input">Fecha: {this.state.date}</div>

					<div className="input">Fruta: 
                    	<Dropdown
                            fluid
                            selection
                            options={[
                                {key:1, text:'Frambuesa', value:'frambuesa'},
                                {key:2, text:'Zarzamora', value:'zarzamora'},
                            ]}
                            name='dateFilter'
                            value={this.state.fruta}
                            onChange={this.handleFrutaChange}
                        />
                    </div>

					<div className="input">Sector: 
                        <Single 
                            tabla='Zonas' 
                            columna='sector'
                            placeholder='sector' 
                            value={this.state.sector}
                            onChange={this.handleSectorChange} 
                            />
                    </div>
                    <div className="input">Cajas Rechazadas: <input type='int' 
					name='totalCajas' required={true} onChange={this.handleCajasChange}/></div>

					<p><button type="submit">Guardar</button></p>
				</form>

			</div>
		)
	}
}
export default Rechazos
